import { Quaternion, Vector3 } from "@babylonjs/core/Maths/math.vector";
/**
 * Ik chain information for solving IK
 */
export class IkChainInfo {
    /**
     * Local rotation of the bone for solving IK
     */
    localRotation;
    /**
     * Local position of the bone for solving IK
     */
    localPosition;
    /**
     * The rotation offset value to be moved by the IK solver
     */
    ikRotation;
    /**
     * Creates IK chain information
     */
    constructor() {
        this.localRotation = Quaternion.Identity();
        this.localPosition = Vector3.Zero();
        this.ikRotation = Quaternion.Identity();
    }
}
